var _defs, _style, _use, _tspan, _tspan2, _tspan3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCsvStackSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_csv_stack-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 230,
    height: 208,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOYAAADQBAMAAADhZwA4AAAAAXNSR0IB2cksfwAAAC1QTFRFAFqjAFqjAFijAAAAAFqkAFqkAFqjAFqkAFqjAFqkAFqkAFmjAFqjAFijAFqjsp77fwAAAA90Uk5TPU0PAMz/M8Jxs8qDKQrNAVjvCwAAAMBJREFUeJztzbEJwlAUQFF/UAI2uoLiBuns3cddXCAz2LhBhgjEDVxBrAIhTRDeS3Vud6tTynGTXTnN/raCOTCZTCaTyQwzq0M0VX2WzG0fbX4vTCaTyXyPu6J5ZjKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWT+Ye5e0eb+umQmxmQymUwmM8Ds2nSz7mZmk06OMZlMJnPS855uM5lMJpPJDDAfbbpZ/wDCJCGInUkndAAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.t0 { font-size: 160px;fill: #005aa4;font-weight: 700;font-family: \"NotoIKEALatin-Bold\", \"Noto IKEA Latin\" } \n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "img1",
    href: "#img1",
    transform: "matrix(.141,0,0,.141,1.406,4.359)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "xls"
  }, /*#__PURE__*/React.createElement("text", {
    id: "xls",
    style: {
      transform: "matrix(.07,0,0,.07,7.875,20.573)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t0"
  }, "x")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    className: "t0"
  }, "l")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    className: "t0"
  }, "s\n")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCsvStackSmall);
export default __webpack_public_path__ + "static/media/ic_csv_stack_small.a75f5b4b9cafe91febc0ce171fd2974c.svg";
export { ForwardRef as ReactComponent };